// Module
var code = "<style>.narrator-readable-text{border:none;background:0 0;color:inherit;border:none;padding:0;font:inherit;cursor:pointer;outline:inherit}</style> <button class=\"narrator-readable-text\">Error loading the model</button>";
// Exports
module.exports = code;